import React from 'react';
import { uuid } from 'uuidv4';
import { format } from 'date-fns';
import { IconBin } from "../../IconBin"; // This is a presentational component, meaning it doesn't mutate data

const RenderAvailability = ({
  day,
  type,
  schedule,
  onRemove,
  onEdit
}) => {
  const Filter = schedule.availabilities.filter(a => a.type === type).map(timeslot => format(day.key, 'dd MM yyyy') === format(timeslot.time.start, 'dd MM yyyy') && /*#__PURE__*/React.createElement("div", {
    key: uuid(),
    className: "timeslot"
  }, /*#__PURE__*/React.createElement("div", {
    className: "timeslot-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "slice-wrapper",
    id: `A${timeslot.id}`,
    style: {
      borderLeftColor: timeslot.type === 'client' ? 'var(--client)' : 'var(--expert)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    title: "Edit",
    onClick: () => {
      onEdit(timeslot);
    },
    style: {
      fontSize: 16,
      fontWeight: 'bold',
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      paddingRight: 15,
      flex: 1,
      backgroundColor: timeslot.type === 'client' ? 'var(--client)' : 'var(--expert)'
    }
  }, format(timeslot.time.start, 'HH:mm'), ' - ', format(timeslot.time.end, 'HH:mm')), /*#__PURE__*/React.createElement("div", {
    className: "close-wrapper",
    title: "Remove",
    onClick: async () => {
      onRemove(timeslot);
    }
  }, /*#__PURE__*/React.createElement(IconBin, null))))));
  return Filter;
};

export default RenderAvailability;